module.exports = __webpack_public_path__ + "static/media/m15cr93.655a67c6.png";